import React, { Component } from 'react'
import Header from '../Components/header/index'
import Footer from '../Components/Footer//index'
import './index.scss'
export default class index extends Component {
  componentWillMount() {
    document.title = '高温温湿度_温湿度_智慧物联网_大数据平台_数字孪生_北京锐控自动化科技有限公司|管理登录'
  }
  render() {
    return (
      <div>
        <Header></Header>
        <div className="longin">
          <div className="longin-user">
            <img src={require('../image/user.png')} className="longin-user-img" style={{ top: '2.05rem ' }}></img>
            <img src={require('../image/suo.png')} className="longin-user-img" style={{ top: '4.5rem ' }}></img>
            <input type="text" className="longin-user-input" placeholder="请输管理员账号" />
            <input type="text" className="longin-user-input" placeholder="请输入你的密码" />
            <div className="longin-user-button">登录</div>
            <div className="longin-user-text">忘记密码</div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    )
  }
}
